import { render, staticRenderFns } from "./purchaserDetails.vue?vue&type=template&id=477ceebd&scoped=true"
import script from "./purchaserDetails.vue?vue&type=script&lang=js"
export * from "./purchaserDetails.vue?vue&type=script&lang=js"
import style0 from "./purchaserDetails.vue?vue&type=style&index=0&id=477ceebd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ceebd",
  null
  
)

export default component.exports